import axios from "axios";
import { getToken } from "./service";
import _ from "underscore";
import qs from "qs";
import Config from "../config";

export interface ScreenListItem {
    title: string; //标题名称
    startTime: string; //开始时间
    durationTime: string; //视频时长
    url: string; //下载地址
    videoId: string; //视频ID
    channelId: number; //频道ID
    vid: string; //直播回放id
    fileId: string; //主屏幕id
    taskId: number; //三分屏id
    fileName: string; //主屏幕视频文件名
    duration: string; //直播回放视频时长
    replay: string; //直播回放预览地址
}

export interface PlayBackListItem {
    channelList: ScreenListItem[];
    channelId: number;
}

/**
 * 查询回放视频
 */

export function getCourseChannel(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .get<SuccessData<PlayBackListItem[]>>(
            "/teacher/channel/getCourseChannel",
            { params: { courseNo, courseSeq }, headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            return _.flatten(_.pluck(data, "channelList")).map(item => ({
                ...item,
                channelId: data[0].channelId,
                durationTime: item.duration,
                url: item.replay
            }));
        });
}

interface MainScreen {
    data: ScreenListItem[];
}

/**
 * 新查询直播记录
 * 视频类型 1三分屏 2.屏幕回放
 */
export interface LiveRecord {
    type: string;
    batchNo?: string;
    courseName: string;
    courseNo: string;
    courseSeq: string;
}
export function getLiveRecord(liveRecordData: LiveRecord) {
    const token = getToken();
    return axios
        .post<SuccessData<MainScreen>>(
            "/teacher/coursewareSource/getOnDemandPlayback",
            qs.stringify({ ...liveRecordData, pageSize: "999", pageNo: "1" }),
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            if (data) {
                return data.data?.map(item => ({
                    ...item
                }));
            }

            return [];
        });
}
/**
 *查询主屏列表
 */

export function getDownloadList(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .get<SuccessData<MainScreen>>("/teacher/channel/getDownloadList", {
            params: { courseNo, courseSeq },
            headers: { token }
        })
        .then(res => res.data.data)
        .then(data => {
            if (data) {
                return data.data.map(item => ({
                    ...item,
                    title: item.fileName
                }));
            }
            return [];
        });
}

export interface ThreeScreenListItem {
    data: {
        contents: ScreenListItem[];
    };
}

/**
 * 获取三分屏列表
 */

export function getPPTVideoList(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .get<SuccessData<ThreeScreenListItem>>(
            "/teacher/channel/getPPTVideoList",
            { params: { courseNo, courseSeq }, headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            if (data) {
                return data.data.contents;
            }
            return [];
        });
}

/**
 * 删除回放视频
 */

export function removeVideo(videoId: string, channelId: number) {
    const token = getToken();
    return axios.post<SuccessData<{ videoId: string; channelId: number }>>(
        "/teacher/channel/removeVideo",
        qs.stringify({ videoId, channelId }),
        { headers: { token } }
    );
}

//删除回放课件
export function deletePolyvPlayBack(vids: string) {
    const token = getToken();
    return axios.post<SuccessData<{ vid: string }>>(
        "/teacher/coursewareSource/deletePolyvPlayBack",
        qs.stringify({ vids }),
        { headers: { token } }
    );
}
/**
 * 直播统计中的互动统计和概况统计
 */
interface LiveStatisticsType {
    chatNum?: number; //聊天次数
    answerCardNum?: number; //答题卡次数
    avgPlaybackUV?: number; //回看平均人数
    avgDuration?: number; //直播平均时长
    answerCardRate?: number; //答题卡参与率
    signRate?: number; //签到参与率
    questionnaireNum?: number; //发布问卷次数
    avgPlaybackPV?: number; //回看平均次数
    signNum?: number; //签到次数
    questionnaireRate?: number; //发布问卷参与率
    avgTotalPlayDuration?: number; //观看平均时长
    avgLiveUV?: number; //在线平均人数
    playbackNum?: number; //累计回访次数
    channelId?: number; //频道号
    sessionsNum?: number; //累计直播次数
}
export function getChannelOverviewAndInteractiveStatistics(channelId: string) {
    const token = getToken();
    return axios
        .post<SuccessData<LiveStatisticsType>>(
            "teacher/polyvCourseData/getChannelOverviewAndInteractiveStatistics",
            qs.stringify({ channelId }),
            { headers: { token } }
        )
        .then(res => {
            if (res.data.code === "2000") {
                return res.data.data;
            }
        });
}

/**
 * 直播统计中的观看统计
 */
export interface ViewType {
    lastActiveTime?: string; //最后进入时间
    orderNum?: number; //序号
    sessionId?: string; //场次id
    userName?: string; //学生姓名
    userId?: string; //学号
    duration?: number; //直播时长
    firstActiveTime?: string; //首次进入时间
    currentDay?: string; //日期
    liveAllTime?: number; //观看时长
    vodAllTime?: number; //观看回放时长
    id?: number; //id
    vodNum?: number; //观看回放次数
    channelId?: string; //频道号
}
export interface DataType {
    userName: string;
    firstActiveTime: string;
    lastActiveTime: string;
    channelId: string;
    myOrderBy?: string;
    userId?: string;
}
export function getChannelViewingStatistics(data: DataType) {
    const token = getToken();
    return axios
        .post<SuccessData<ViewType[]>>(
            "teacher/polyvCourseData/getChannelViewingStatistics",
            qs.stringify(data),
            { headers: { token } }
        )
        .then(res => {
            if (res.data.code === "2000") {
                return res.data.data;
            } else {
                return [];
            }
        });
}
/**
 * 直播统计中的在线人数统计
 */
export interface OnlineStSuccessData {
    currentDay: string; //日期
    liveUV: number; //数量
    id: number;
}
export function getChannelOnlinePeopleNumStatistics(
    channelId: string,
    time: [string, string]
) {
    const token = getToken();
    function getUnixTime(time: string) {
        return new Date(time).getTime();
    }
    const startTime = getUnixTime(time[0] + " 0:0:0");
    const endTime = getUnixTime(time[1] + " 23:59:59");
    return axios
        .post<SuccessData<OnlineStSuccessData[]>>(
            "/teacher/polyvCourseData/getChannelOnlinePeopleNumStatistics",
            qs.stringify({ channelId, startTime, endTime }),
            { headers: { token } }
        )
        .then(res => {
            if (res.data.code === "2000") {
                return res.data.data;
            } else {
                return [];
            }
        });
}
/**
 * 导出观看统计
 * @param courseNo
 * @param courseSeq
 */
export function exportViewCount(channelId: string) {
    const token = getToken();
    window.open(
        `${
            Config.ApiHost
        }/teacher/polyvCourseData/exportChannelViewingStatistics?channelId=${channelId}&token=${encodeURIComponent(
            token!
        )}`
    );
}
/**
 * 导出聊天记录
 * @param courseNo
 * @param courseSeq
 */
export function exportChat(channelId: string) {
    const token = getToken();
    window.open(
        `${
            Config.ApiHost
        }/teacher/polyvCourseData/exportChannelChatDetailStatistics?channelId=${channelId}&token=${encodeURIComponent(
            token!
        )}`
    );
}
